<template>
  <Card
    v-if="isDisabled || !hasCPIAdjustment"
    :is-disabled="isDisabled"
    :has-c-p-i-adjustment="hasCPIAdjustment"
    :is-full-height="isFullHeight"
    :landlord-id="landlordId"
    :tenancy-id="tenancyId"
    @click="$emit('click')"
  />
  <router-link v-else :to="$options.SETTINGS_LINK" class="no-link-styles">
    <Card
      :has-c-p-i-adjustment="hasCPIAdjustment"
      :next-c-p-i-adjustment="nextCPIAdjustment"
      :is-full-height="isFullHeight"
      :landlord-id="landlordId"
      :tenancy-id="tenancyId"
      @click="$emit('click')"
    />
  </router-link>
</template>

<script>
import Card from './Card.vue';
import moment from 'moment';

export default {
  components: {
    Card,
  },
  props: {
    landlordId: [String, Number],
    tenancyId: [String, Number],
    isDisabled: {
      type: Boolean,
      default: false,
    },
    rentAdjustment: {
      type: Object,
      default: undefined,
    },
    isFullHeight: {
      type: Boolean,
      default: false,
    },
  },
  SETTINGS_LINK: {
    name: 'tenancy_settings',
    query: { highlight: 'kpi' },
  },
  computed: {
    hasCPIAdjustment() {
      return this.rentAdjustment.CPIAdjustment;
    },
    nextCPIAdjustment() {
      const lastAdjustment = this.rentAdjustment.lastCPIAdjustment;
      if (lastAdjustment == null) return;
      const nextCPIAdjustment = moment(lastAdjustment).add(1, 'year');
      return nextCPIAdjustment.format('MMMM YYYY');
    },
  },
};
</script>
